import { useQuery } from '@tanstack/react-query';
import { OrganizationService } from '../OrganizationService';

// Organization queries
export const useOrganizations = ({ pageNo, pageSize }) =>
  useQuery({
    queryKey: ['organizations', 'list', pageNo, pageSize],
    queryFn: () => OrganizationService.listAllOrganizations(pageNo, pageSize),
    enabled: !!pageNo && !!pageSize,
  });

// RM queries
export const useRMList = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ['organizations', 'rm-list'],
    queryFn: () => OrganizationService.getRMList(),
    enabled,
  });

// Organization users queries
export const useOrganizationUsers = (
  organizationId,
  pageNo = 1,
  pageSize = 10
) =>
  useQuery({
    queryKey: ['organizations', 'users', organizationId, pageNo, pageSize],
    queryFn: () =>
      OrganizationService.getOrganizationUsers(
        organizationId,
        pageNo,
        pageSize
      ),
    enabled: !!organizationId,
  });
